module.exports = __webpack_public_path__ + "img/banner2.7431739b.jpg";